  
import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { QuickLoanService } from "../services/quickLoan.service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LosService } from "../../_LOS/services/los.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { LmsService } from "../../_Lms/services/lms.service";

interface ReportItems {
  Item1?: any[];
  Item2?: any[];
  Item3?: any[];
  Item4?: any[];
  Item5?: any[];
  Item6?: any[];
  Item7?: any[];
  Item8?: any[];
  Item9?: any[];
  Item10?: any[];
  Item11?: any[];
  Item12?: any[];
  Item13?: any[];
}
@Component({
  selector: 'app-losreports',
  templateUrl: './losreports.component.html',
  styleUrls: ['./losreports.component.scss']
})
export class LosreportsComponent implements OnInit {
  @Input() reportIndex: number = 0; // Index for the selected report (0-11)
  DateFrom: any = '';
  DateTo: any = '';
  BranchId: any = 0;
  ReportData: any[] = [];
  maxDate: Date = new Date();
  showSpinner: boolean = false;
  BranchesList: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  MaindataSource: ReportItems;
  currentUser: any;
  ReportIndex: any;
  ReportName: string;
  columnDisplayNames = {
      Loan_Id: '#',
      Application_No: 'Application No',
      BranchName : 'Branch',
      ProductName: 'Product',
      Customer_Name: 'Customer',
      Process: 'Process',
      ProcessStatus: 'Process Status',
      EmployeeName: 'Employee',
      AssignedOn: 'Assigned On',
      CompletedOn: 'Completed On',
      TAT_Hr: 'TAT (Hr)',
      Maximum_Standard_Tat: 'Max Tat',
      TAT_Status: 'TAT Status',
      TimeTaken_InPercent: 'Time Taken (%)'
      // ...add other mappings
};
  displayedColumns: string[] = [
    'Loan_Id',
    'Application_No',
    'Branch',
    'Product',
    'Customer',
    'Process',
    'ProcessStatus',
    'EmployeeName',
    'AssignedOn',
    'CompletedOn',
    'TAT_Hr',
    'Max_Standard_Tat',
    'TAT_Status',
    'TimeTaken_In%'
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  ngAfterViewInit(): void {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }
  
  
  

  constructor(
      private QuickLoanService: QuickLoanService,
      private dataSharingService: DataSharingService,
      private _Route: Router,
      private route: ActivatedRoute,
      private _MasterService: MasterService,
      private _EncrDecrService: EncrDecrService,
      private losService: LosService,
      private snackBar: MatSnackBar,
      private lmsService: LmsService,
  
    ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("QuickLoan Dashboard");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.ReportIndex = Number(this._EncrDecrService.decrypt(decodeURIComponent(param.get("Rid"))));
      this.ReportName = param.get("RName")
        ? decodeURIComponent(this._EncrDecrService.decrypt(param.get("RName"))).replace(/%20/g, " ")
        : "";
      this.DateFrom = param.get("PFrom")
        ? new Date(decodeURIComponent(this._EncrDecrService.decrypt(param.get("PFrom"))))
            .toISOString()
            .split("T")[0]
        : "";

      this.DateTo = param.get("PTo")
        ? new Date(decodeURIComponent(this._EncrDecrService.decrypt(param.get("PTo"))))
            .toISOString()
            .split("T")[0]
        : "";
      // Set a readable title
      const title = `${this.ReportName}`;
      this.dataSharingService.HeaderTitle.next(title);
      this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      console.log("ReportIndex", this.ReportIndex, "DateFrom", this.DateFrom, "DateTo", this.DateTo);
      this.getReportData();
    });
    
  }

  getBranchesList() {
    // TODO: Replace with actual API call
    // Example:
    // this.reportService.getBranches().subscribe((res: any) => {
    //   this.BranchesList = res;
    // });
    this.BranchesList = [
      { BranchId: 1, Branch_Name: 'Branch 1' },
      { BranchId: 2, Branch_Name: 'Branch 2' }
    ];
  }
  goBackToDashboard() {
    this._Route.navigate(['/quickloan-dashboard/dashboard']);
  }
  getReportData() {
    this.showSpinner = true;
    this.QuickLoanService.QuickLoan_LOS_Reports({
      LoginUserId: this.currentUser.userId,
      FromDate: this.DateFrom,
      To: this.DateTo,
      ReportId: this.ReportIndex
    }).subscribe((res: any) => {
      this.MaindataSource = res as ReportItems;
      // Dynamically assign dataSource and columns based on ReportIndex
      let itemData: any[] = [];
      if (this.ReportIndex === 1 && this.MaindataSource.Item1) {
        itemData = this.MaindataSource.Item1;
      } else if (this.ReportIndex === 2 && this.MaindataSource.Item2) {
        itemData = this.MaindataSource.Item2;
      } else if (this.ReportIndex === 3 && this.MaindataSource.Item3) {
        itemData = this.MaindataSource.Item3;
      } else if (this.ReportIndex === 4 && this.MaindataSource.Item4) {
        itemData = this.MaindataSource.Item4;
      } else if (this.ReportIndex === 5 && this.MaindataSource.Item5) {
        itemData = this.MaindataSource.Item5;
      } else if (this.ReportIndex === 6 && this.MaindataSource.Item6) {
        itemData = this.MaindataSource.Item6;
      } else if (this.ReportIndex === 7 && this.MaindataSource.Item7) {
        itemData = this.MaindataSource.Item7;
      } else if (this.ReportIndex === 8 && this.MaindataSource.Item8) {
        itemData = this.MaindataSource.Item8;
      } else if (this.ReportIndex === 9 && this.MaindataSource.Item9) {
        itemData = this.MaindataSource.Item9;
      } else if (this.ReportIndex === 10 && this.MaindataSource.Item10) {
        itemData = this.MaindataSource.Item10;
      } else if (this.ReportIndex === 11 && this.MaindataSource.Item11) {
        itemData = this.MaindataSource.Item11;
      } else if (this.ReportIndex === 12 && this.MaindataSource.Item12) {
        itemData = this.MaindataSource.Item12;
      } else if (this.ReportIndex === 13 && this.MaindataSource.Item13) {
        itemData = this.MaindataSource.Item13;
      }
      this.dataSource.data = itemData || [];
      // Attach paginator and sort after data assignment
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      console.log('itemData:', itemData);
      // Set columns dynamically based on keys in first row, excluding LoanIdentity
      if (itemData && itemData.length > 0) {
        this.displayedColumns = Object.keys(itemData[0]).filter(col => col !== 'LoanIdentity');
        console.log('displayedColumns:', this.displayedColumns);
      } else {
        this.displayedColumns = [];
        console.log('No data for this report index.');
      }
      console.log("Report Data:", this.MaindataSource);
      this.showSpinner = false;
    });
    this.DateFrom = "";
    this.DateTo = "";
  }

// QuickLoan_LOS_Reports(){
//   this.showSpinner = true;
//     this.QuickLoanService.QuickLoan_LOS_Reports_Summary({
//       LoginUserId: this.currentUser.userId,
//       FromDate: this.DateFrom,
//       To: this.DateTo,
//     }).subscribe((res: any) => {
//       this.ReportData = res;
//       this.showSpinner = false;
//     });
// }

  goToDetail(row: any) {
    // TODO: Implement navigation to detail view for the selected row
    // Example: this.router.navigate([`/losreports/detail/${row.Application_No}`]);
    alert('Go to detail for ' + row.Application_No);
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  exportexcelReport() {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    // Build a plain HTML table from dataSource.data and displayedColumns, excluding Loan_Id
    if (!this.dataSource || !this.dataSource.data || !this.displayedColumns || this.displayedColumns.length === 0) {
      alert('No data to export!');
      return;
    }
    const exportColumns = this.displayedColumns.filter(col => col !== 'Loan_Id' && col !== 'LoanIdentity');
    let html = '<table border="1">';
    // Header row
    html += '<tr>';
    html += '<th>#</th>';
    for (const col of exportColumns) {
      html += `<th>${col}</th>`;
    }
    html += '</tr>';
    // Data rows
    for (let i = 0; i < this.dataSource.data.length; i++) {
      const row = this.dataSource.data[i];
      html += '<tr>';
      html += `<td>${i + 1}</td>`;
      for (const col of exportColumns) {
        let cell = row[col] !== undefined && row[col] !== null ? row[col] : '';
        html += `<td>${cell}</td>`;
      }
      html += '</tr>';
    }
    html += '</table>';

    const worksheetName = this.ReportName || "LOS Report";
    const ctx = { worksheet: worksheetName, table: html };
    const downloadLink = document.createElement("a");
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = worksheetName + ".xls";
    downloadLink.click();
  }
}
